import axios from 'axios';

export default class IncidentService {



  static async getAllIncidents(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/get-incidents`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getIncident(token, id) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/get-incident?incidentId=`+id,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  

  
}
